import Constant from '@/const';
import axios from 'axios';

const putStatusSupplier = async (id, payload) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/supplier/status/${id}`),
      payload,
    );
    return response;
  } catch (error) {
    return error;
  }
};

export default putStatusSupplier;
